import * as IconSelector from '../icons';

// Constantes exportadas
export const TYPE_REPRESENTATIVE_BODEGA = 'Bodega';
export const TYPE_REPRESENTATIVE_VITICULTOR = 'Viticultor';

// Definición del enum
export const typeRepresentative = [
    {
        value: null,
        label: 'Sin definir',
        icon: IconSelector.NotDefinedIcon,
        color: 'Black'
    },
    {
        value: TYPE_REPRESENTATIVE_BODEGA,
        label: 'Bodega',
        description: 'Representante de una bodega',
        icon: IconSelector.BodegaIcon,
        color: 'Blue'
    },
    {
        value: TYPE_REPRESENTATIVE_VITICULTOR,
        label: 'Viticultor',
        description: 'Representante de un viticultor',
        icon: IconSelector.ViticultorIcon,
        color: 'Green'
    }
];
